<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("novo-grupo-produto") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="voltar"
                >
                    {{ $t("voltar") }}
                </button>
                <button class="save-btn" type="button" @click="saveGrupoPergunta">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6">
                            <v-input 
                                :id="'idErp'"
                                ref="idErpInput"
                                v-model="gp.idgrupoprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!gp.idgrupoprodutoerp"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                v-model="gp.descricao"
                                id="descricao"
                                placeholder="descricao-do-gp-placeholder"
                                :maxlength="50"
                                title="descricao-do-grupo-produto"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!gp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Services
import GrupoProdutoService from "@/services/GrupoProdutoService";
import GrupoProdutoValidation from "@/services/validations/GrupoProdutoValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            isSaving: false,
            gp: {
                nomeunico: null,
                idempresa: 0,
                situacao: 1,
            },
            msgs: []
        };
    },
    created() {
        this.service = new GrupoProdutoService(this.$http, this.$router);
        this.validation = new GrupoProdutoValidation(this.msgs);
    },
    methods: {
        voltar() {
            this.$emit("voltar")
        },
        saveGrupoPergunta() {
            this.isSaving = true;
            this.gp = this.mapTosave(this.gp);
            // @84563 - Request para verificar se já existe grupo com a descrição associada a esta empresa
            if (this.validation.validate(this.gp, this.$refs)) {
                this.service
                    .save(this.gp)
                    .then((body) => {
                        if (body.content) {
                            let msg = "msg-grupo-produto-salvo";
                            this.gp = body.content;
                            this.msgs.push(
                                new Message("success", msg, true)
                            );

                            let objEmit = {
                                'origem': 'grupo',
                                'obj': { id: this.gp.id, label: this.gp.descricao } 
                            };

                            setTimeout(() => {
                                this.$emit('sucesso', objEmit);
                            }, 1000);
                        } else {
                            if (this.$te(body.message)) {
                                if (body.message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(body.message, { n: this.gp.idgrupoprodutoerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', body.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(
                            new Message(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            )
                        );
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    background-color: $sovis-white;
}
</style>